import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  Card,
  CardProps,
  CardActionArea,
  CardHeader,
  cardHeaderClasses,
} from "@mui/material";

export const PatientBackCta: React.FC<CardProps> = ({ ...cardProps }) => {
  const { t } = useTranslation();
  return (
    <Card {...cardProps}>
      <CardActionArea component={Link} to="/protected/all-patients">
        <CardHeader
          avatar={
            <ArrowBackIcon fontSize="small" sx={{ color: "text.secondary" }} />
          }
          subheader={t("patients.all-text")}
          title={t("patients.all-cta")}
          titleTypographyProps={{ noWrap: true, variant: "subtitle1" }}
          sx={{
            [`& .${cardHeaderClasses.action}`]: { alignSelf: "center" },
          }}
        />
      </CardActionArea>
    </Card>
  );
};
